import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=b5ac639c&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=b5ac639c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ac639c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5ac639c')) {
      api.createRecord('b5ac639c', component.options)
    } else {
      api.reload('b5ac639c', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=b5ac639c&scoped=true", function () {
      api.rerender('b5ac639c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/Navigation.vue"
export default component.exports